import ArrowLeftIcon from "../../../../../../../assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "../../../../../../../assets/icons/ArrowRightIcon"
import RcmpLoading from "../../../../../../atoms/Loading"

import styles from "./index.module.scss"
import Table from "./table"
import { useTableAnalysis } from "./useTableAnalysis"

export const TableAnalysis = ({
  runs,
  anlt_nid,
  idx,
  setSelectedRun,
  selectedRun,
  className,
  pagination = true,
  setIsOpen,
}) => {
  const {
    aTableData,
    selectedHeader,
    selectedColumn,
    setLimit,
    limit,
    handleCellClick,
    oFetchRunRes,
    fetchRun,
  } = useTableAnalysis({
    aRuns: runs,
    anlt_nid,
    idx,
    pagination,
    setSelectedRun,
    selectedRun,
  })

  // runs show in the table
  const aCurrentTableData = aTableData?.length
    ? aTableData.slice(limit.init, limit.final)
    : []

  return (
    <div className={`${styles.wrapper} ${className ? className : ""}`}>
      {pagination && (
        <div className={styles.prevArrow}>
          {!oFetchRunRes.loading && (
            <ArrowLeftIcon
              className={styles.arrowIcon}
              onClick={() => {
                if (
                  aCurrentTableData.map((it) => it.eqpanltrun_number)[0] <= 1 &&
                  limit.init === 0
                ) {
                  return
                } else if (limit.init !== 0) {
                  setLimit((prev) => ({ init: prev.init - 1, final: prev.final - 1 }))
                  return
                }
                fetchRun(aTableData.map((it) => it.eqpanltrun_number)[0])
              }}
              disabled={
                aCurrentTableData.map((it) => it.eqpanltrun_number)[0] <= 1 &&
                limit.init === 0
              }
            />
          )}
          <RcmpLoading bShow={oFetchRunRes.loading} size={30} />
        </div>
      )}

      <Table
        aTableData={aCurrentTableData}
        setIsOpen={setIsOpen}
        selectedHeader={selectedHeader}
        selectedColumn={selectedColumn}
        onClick={handleCellClick}
        setSelectedRun={setSelectedRun}
      />

      {pagination && (
        <ArrowRightIcon
          className={styles.arrowIcon}
          onClick={() => {
            if (aTableData.length <= limit.final) {
              return
            }

            setLimit((prev) => ({ init: prev.init + 1, final: prev.final + 1 }))
          }}
          disabled={aTableData?.length <= limit.final}
        />
      )}
    </div>
  )
}
